'use client';
import { create } from 'zustand';

interface SettingsStore {
  // ---- Save state ----
  isSaving: boolean;
  saveMessage: string | null;

  // ---- Actions ----
  setIsSaving: (value: boolean) => void;
  setSaveMessage: (value: string | null) => void;
}

export const useSettingsStore = create<SettingsStore>((set) => ({
  // ---- Save state ----
  isSaving: false,
  saveMessage: null,

  // ---- Actions ----
  setIsSaving: (value) => set({ isSaving: value }),
  setSaveMessage: (value) => set({ saveMessage: value }),
}));
